import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';

import { cancelCustomerLead, cancelKamOrder } from '../../../common/helper/api.helper';
import { cancelCart } from 'home/view/manage-feasibility/services';
import { findParamFromUrl, getFromSessionStorage, getOrderDetails, stopBackgroundScrolling } from '../../../common/utils/app.utils';
import { MODULE_ID, PNQ_AUTHORIZATION_HEADER, SELECTED_PARTY_ACCOUNT } from '../../../home/common/constants/constants';
import { ROUTES } from '../../../common/constants/app.constants';
import { cancelOrderForSummary } from '../../../common/services/http.service';
import { AUTH_TOKEN, MULTI_SITE_MODULE_ID, CART_ID, DEFAULT_TOAST_MSG, ERROR_TOAST } from 'home/view/manage-feasibility/constants';

const CancelOrderPopup = ({
  setToast = () => {},
  isdedicatedJourney = false,
  showCancelCart = false,
  setshowPopup,
  setdisabled,
  isSummaryPage,
  isCustomerCancel,
  onLoad,
  onSubmit,
  isMultiSite = false,
  metaData = {},
  isUpgrade = false
}) => {
  const partyId = findParamFromUrl('partyId') ? findParamFromUrl('partyId') : getFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);

  const [remarks, setRemarks] = useState('');
  const history = useHistory();
  useEffect(() => {
    onLoad && onLoad();
  }, []);

  const hidePopup = () => {
    setshowPopup(false);
    stopBackgroundScrolling(false);
  };

  const cancelOrder = () => {
    let payload = {
      remarks
    };
    let pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
    cancelKamOrder(payload, pnqToken)
      .then(() => {
        hidePopup();
        setdisabled?.(true);

        let redirectUrl = ROUTES.DEDICATED_CANCEL;

        // Cancel lead on KAM Page does not have orderId. Hence, leadId is used.
        const cancelledLeadId = metaData?.orderId || metaData?.leadId;

        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }
        history.push(redirectUrl, { ...getOrderDetails(cancelledLeadId), isUpgrade });
      })
      .catch((err) => console.error(err));
  };
  const cancelLead = () => {
    let payLoad = {};
    payLoad.remarks = remarks;
    cancelCustomerLead(payLoad, true)
      .then(() => {
        hidePopup();

        let redirectUrl = ROUTES.DEDICATED_CANCEL;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }
        history && history.push(redirectUrl, { ...getOrderDetails(), isUpgrade });
      })
      .catch((err) => console.error(err));
  };
  const onCancelSummary = () => {
    cancelOrderForSummary(remarks, isMultiSite).then(
      () => {
        hidePopup();

        let redirectUrl = ROUTES.DEDICATED_CANCEL;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }
        history.push(redirectUrl, { via: 'SUMMARY', ...getOrderDetails(metaData?.orderId), isUpgrade });
      },
      (err) => console.error(err)
    );
  };

  const cancelCartCb = async () => {
    try {
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const cartId = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID);

      const reqData = {
        remarks,
        cartId
      };
      const { res, err } = await cancelCart(reqData, leadAuthToken, isdedicatedJourney);
      if (res) {
        const { data: { success = false } = {} } = res;
        if (success) {
          let redirectUrl = ROUTES.DEDICATED_CANCEL;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }

          hidePopup();
          history && history.push(redirectUrl, { ...getOrderDetails(cartId), isUpgrade });
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
    }
  };

  const getCallingFn = () => {
    if (showCancelCart) {
      return cancelCartCb;
    }

    return isSummaryPage || isMultiSite ? onCancelSummary : isCustomerCancel ? cancelLead : cancelOrder;
  };

  const onSubmitOrder = () => {
    const callfn = getCallingFn();

    callfn && callfn();
    onSubmit && onSubmit({ remarks });
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder">
        <h2>Cancel Order</h2>
        <p>Please share your reason below to cancel the order.</p>
        <TextArea name="demo" label="Reason for cancellation" placeholder="Enter Description" required value={remarks} onChange={(value) => setRemarks(value)} maxLength={150} />
        <div className="characters">&nbsp;</div>
        <div className="buttonSection">
          <button type="button" className="btn activebtn" onClick={hidePopup}>
            Cancel
          </button>
          <button type="button" className="btn activebtn btn-transparent" onClick={onSubmitOrder}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelOrderPopup;
